export const createFormData = (object: any,
    form?: FormData,
    namespace?: string): FormData => {
    const formData = form || new FormData();
    for (let property in object) {
        if (!object.hasOwnProperty(property)) {
            continue;
        }

        if (property === "hasImage") {
            formData.append(namespace ? `${namespace}[${property}]` : property, String(object[property]));
            continue;
        }

        if (!object[property]) {
            continue;
        }

        const formKey = namespace ? `${namespace}[${property}]` : property;
        if (object[property] instanceof Date) {
            formData.append(formKey, object[property].toISOString());
        } else if (
            typeof object[property] === "object" &&
            !(object[property] instanceof File)
        ) {
            createFormData(object[property], formData, formKey);
        } else {
            formData.append(formKey, object[property]);
        }
    }
    
    return formData;
}

export const emulateApiCall = async () => {
    return new Promise((res, rej) => {
        setTimeout(() => {
            res('')
        }, 3000)
    })
}

export const isContained = (container: any[], target: any[]) => {
    const res = target.filter(v => !container.includes(v))
    return res.length > 0 ? false : true;
};


export const stringArrayToTagArray = (arr: string[]) => arr.map(t => ({ label: t, value: t }))

export const stringObjToObj = (s: string) => {
    return JSON.parse(s);
}

export const truncate = (str: string, max: number, suffix: string) => str.length < max ? str : `${str.substring(0, max)}${suffix}`;


export const openFile = (url: string, e: any) => {
    e.stopPropagation();
    var string = url;
    var iframe = "<iframe width='100%' height='100%' src='" + string + "'></iframe>"
    var x: any = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();
}

export const extractFileExtention = (fileName: string) => {
    if (fileName){
        const res : any = (/[.]/.exec(fileName)) ? /[^.]+$/.exec(fileName) : undefined;
        return res[0];
    }
}

export const clean = (obj: any) => {
    for (var propName in obj) {
        if (obj[propName] === "" || obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj
}

export const toFormData = (obj: any) => {
    try {
        const formData = new FormData();
        for (const key in obj) {
            formData.append(key, obj[key]);
        }
        return formData
    } catch (err) {
        throw err
    }

}